module.exports = __webpack_public_path__ + "img/EOS.4fd4557f.svg";